import { render, staticRenderFns } from "./wikiViewer.vue?vue&type=template&id=8d063920&scoped=true&"
import script from "./wikiViewer.vue?vue&type=script&lang=js&"
export * from "./wikiViewer.vue?vue&type=script&lang=js&"
import style0 from "./wikiViewer.vue?vue&type=style&index=0&id=8d063920&prod&lang=scss&scoped=true&"
import style1 from "./wikiViewer.vue?vue&type=style&index=1&id=8d063920&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d063920",
  null
  
)

export default component.exports